import React from 'react';
import { useSavedItems } from '../../hooks/useSavedItems';
import { usePreferences } from '../../hooks/usePreferences';
import { pluralize } from './pluralize';
import { ShoppingBagNotification } from './ShoppingBagNotification';

export const BackInStockNotification: React.FC = () => {
  const { savedItems } = useSavedItems();
  const { backInStockNotifications, setPreference } = usePreferences();

  const backInStockItems = savedItems.filter(item => item.attributes.backInStock);

  if (backInStockItems.length === 0) return null;
  if (!backInStockNotifications) return null;

  return (
    <ShoppingBagNotification
      color="money-good"
      title={
        <>
          {backInStockItems.length} {pluralize('item', backInStockItems.length)} in your 'Saved for
          Later' {pluralize('is', backInStockItems.length)} back in stock! Move to bag and proceed
          to checkout to purchase.
        </>
      }
      onClose={() => setPreference('backInStockNotifications', false)}
    />
  );
};
